import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function GallerySection() {
  // We duplicate the images to create a seamless infinite scroll effect
  const images = [
  // Alternating sequence: platinum/white ↔ dark
  'https://cdn.magicpatterns.com/uploads/efZN5ab46ckJBidWm98pop/Corte_3listo.png', 'https://cdn.magicpatterns.com/uploads/ipT94TBtNPTnoj49CWKuaP/Corte1.png', 'https://cdn.magicpatterns.com/uploads/uhAUxqmWqG2861VZurPcsm/Corte_5listo.png', 'https://cdn.magicpatterns.com/uploads/uYqcpZh5TBy4Ftq8ifD2Sh/Corte_2.png'];
  // Double the array for the marquee effect
  const marqueeImages = [...images, ...images];
  return <section id="galeria" className="py-24 overflow-hidden" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16" data-id="element-136">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-137">
          Galería de cortes
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-gray-400 max-w-xl mx-auto" data-id="element-138">
          Resultados reales. Limpio, prolijo y con estilo.
        </motion.p>
      </div>

      {/* Animated Marquee Container */}
      <div className="relative w-full overflow-hidden flex group mb-16" data-id="element-139">
        {/* Left/Right Fade Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-dark to-transparent z-10 pointer-events-none" data-id="element-140" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-dark to-transparent z-10 pointer-events-none" data-id="element-141" />

        <div className="flex w-max flex-nowrap animate-marquee group-hover:[animation-play-state:paused] gap-4 md:gap-8 px-4 md:px-8" data-id="element-142">
          {marqueeImages.map((src, index) => <div key={index} className="w-[75vw] sm:w-[55vw] md:w-[40vw] lg:w-[30vw] flex-shrink-0 aspect-square rounded-2xl overflow-hidden border border-white/10 shadow-2xl relative" data-id="element-143">
              <img src={src} alt={`Corte de pelo ${index % images.length + 1}`} className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-700" loading="lazy" draggable={false} data-id="element-144" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-145">
                <div className="w-8 h-8 rounded-full bg-gold/20 border border-gold/50 flex items-center justify-center backdrop-blur-sm" data-id="element-146">
                  <div className="w-2 h-2 rounded-full bg-gold" data-id="element-147" />
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="flex justify-center px-4" data-id="element-148">
        <a href="#sucursales" className="bg-transparent border border-gold text-gold hover:bg-gold hover:text-dark font-bold py-4 px-10 rounded-full transition-all duration-300" data-id="element-149">
          Ver disponibilidad y reservar
        </a>
      </motion.div>
    </section>;
}